import { createStore } from 'vuex'
import tabs from "./data/tabs"

export default createStore({
  state: {
    config: {
      url: "001210.com"
    },
    tabs
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
